module.exports = __webpack_public_path__ + "img/star-07.7900a6cf.svg";